import axiosCommon from '@/api/axiosCommon'
import axios from 'axios'
let user = {
  namespaced: true,
  state: {
    isLogin: false,
    loginName:""
    // accountInfo:null
  },
  mutations: {
    isLogin(state, data) {
      state.isLogin = data
    },
    setLoginName(state, data) {
      state.loginName = data
    },
  },
  actions: {
    // 查询账号信息
    async getLogin({commit}) {
      let res = await axiosCommon.get('/rest/isLogin')

      if (res.id) {
        commit('isLogin', false)
      } else {
        commit('isLogin', true)
        commit('setLoginName', res.accountName)
      }
      return res
    },
    // 登录
    async goToLogin({commit}, payload) {
      let res = await axiosCommon.post('/rest/login', payload)
      
      if (res) {
        
        commit('setLoginName', res.accountName)
        return res
      }
    },
    // 登出 
    async goToLogout({commit},payload){
      let res = await axiosCommon.post('/rest/logout', payload)
      
      if(res===true){
        
        return res
      }
    },


    // 获取验证码
    async getCode() {
      let res = await axios({
        method: 'get',
        url: 'api/rest/code/getCode',
        responseType: 'blob'
      })
      if (res) {
        return res.data
      }
    },

    // 修改密码
    async updatePwd({ commit }, params) {
      let result = await axiosCommon.post("/rest/updatePwd", params);
      if (result) {
        return result;
      }
    },
     // 底部版权信息
     async getFooterCopyright({ commit }, params) {
      let result = await axiosCommon.get("/rest/copyright", params);
      if (result) {
        return result;
      }
    },

  }
}

export default user
